import { Error } from "./error";
import type { FormErrors } from "@repo/shared-types";
import { Button } from "../button";
import { useRef } from "react";
import { Upload } from "lucide-react";

interface FileProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  errors?: FormErrors;
  children?: React.ReactNode;
}

export function File({
  label,
  className = "",
  errors,
  children,
  ...props
}: FileProps) {
  const showError = errors?.[props.name ?? ""];
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="flex flex-col gap-1">
      <input
        {...props}
        key={props.name}
        className={`w-full outline-none hidden ${className}`}
        type="file"
        ref={inputRef}
      />
      {children ? (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="cursor-pointer flex flex-col items-center justify-center gap-2"
        >
          {children}
        </button>
      ) : (
        <Button type="button" onClick={() => inputRef.current?.click()}>
          <Upload className="w-4 h-4" />
          Subir
        </Button>
      )}

      {showError && <Error fieldName={props.name} errors={errors} />}
    </div>
  );
}
